import React from "react";
import { BlobProvider } from "@react-pdf/renderer";
import {
  Page,
  Text,
  View,
  Document,
  StyleSheet,
  Image,
  Link,
  Font,
} from "@react-pdf/renderer";
import config from "../../../../../../../config";
import { toast } from "react-toastify";
import { NOTIFICATION_MESSAGES } from "app/components/ConditionalEnums";
import { saveAs } from "file-saver";
import constants from "utils/constants";
const axios = require("axios").default;

// Disable automatic hyphenation so words are only wrapped at spaces
Font.registerHyphenationCallback((word) => [word]);

export const styles3 = StyleSheet.create({
  page: {
    backgroundColor: "white",
    color: "black",
    fontSize: 14,
    display: "flex",
    flexDirection: "column",
    width: "100%",
    padding: 30,
  },
  titlePage: {
    position: "relative",
    flex: 1,
    width: "100%",
    height: "100%",
    justifyContent: "space-between",
  },
  titlePageWrapper: {
    padding: 0,
  },
  titleBackground: {
    position: "absolute",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    width: "100%",
    height: "100%",
    objectFit: "cover",
    objectPosition: "center",
  },
  titleContent: {
    position: "relative",
    flex: 1,
    justifyContent: "space-between",
    padding: 48,
    paddingBottom: 96,
  },
  titleTopRow: {
    flexDirection: "row",
    justifyContent: "flex-end",
    alignItems: "center",
  },
  titleLogo: {
    height: 100,
    width: "auto",
  },
  titleBody: {
    marginTop: 160,
    maxWidth: "70%",
  },
  titleHeading: {
    fontSize: 32,
    fontWeight: "bold",
    lineHeight: 1.2,
  },
  titleMeta: {
    marginTop: 48,
    flexDirection: "column",
  },
  titleMetaLabel: {
    fontSize: 14,
    fontWeight: "500",
    marginBottom: 12,
  },
  titleFooterText: {
    fontSize: 8,
    lineHeight: 1.4,
    marginTop: 24,
    maxWidth: "70%",
  },
  section: { marginBottom: 24 },
  overviewHeading: {
    fontSize: 18,
    fontWeight: "bold",
    textAlign: "left",
  },
  overviewColumns: {
    flexDirection: "row",
    justifyContent: "space-between",
    gap: 10,
    height: "60px",
  },
  overviewColumn: {
    width: "32%",
  },
  overviewColumnHeader: {
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    marginBottom: 8,
  },

  overviewIconImage: { width: 30, height: 30, borderRadius: 50 },

  overviewColumnTitle: {
    fontSize: 14,
    fontWeight: "bold",
    marginLeft: 10,
  },
  overviewColumnDivider: {
    width: "100%",
    height: 1,
    backgroundColor: "#D5D5D3",
    marginTop: 4,
    marginBottom: 12,
    alignSelf: "stretch",
  },
  overviewItem: {
    flexDirection: "row",
    alignItems: "flex-start",
    marginBottom: 5,
  },
  overviewBullet: {
    fontSize: 10,
    marginRight: 2,
  },
  overviewItemContent: {
    flex: 1,
  },
  overviewLabelWrapper: {
    borderRadius: 2,
    paddingHorizontal: 1,
    paddingVertical: 1,
  },

  overviewLabel: {
    fontSize: 12,
    fontWeight: "bold",
  },
  overviewLink: {
    fontSize: 12,
    fontWeight: "bold",
    color: "#0066CC",
    textDecoration: "underline",
  },
  overviewSecondary: {
    fontSize: 9,
    marginTop: 4,
    marginLeft: 2,
  },
  overviewNote: {
    fontSize: 8,
    fontStyle: "italic",
    marginTop: 2,
    marginLeft: 2,
    lineHeight: 1.2,
  },
  overviewSubItem: {
    flexDirection: "row",
    alignItems: "flex-start",
    marginTop: 4,
    marginLeft: 10,
  },
  overviewSubBullet: {
    fontSize: 8,
    marginRight: 4,
  },
  overviewSubText: {
    fontSize: 10,
  },

  graphContainer: {
    width: "100%",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
  },

  headingContainer: {
    marginTop: 12,
    marginBottom: 16,
    paddingVertical: 8,
    // paddingHorizontal: 16,
    alignItems: "flex-start",
  },
  graphImage: { width: 400, height: 300 },
  graphCaption: { fontSize: 9, marginTop: 8 },
  tableContainer: {
    width: "100%",
    borderWidth: 0.8,
    borderColor: "#D5D5D3",
    borderRadius: 6,
    backgroundColor: "#FFFFFF",
  },
  tableHeader: {
    flexDirection: "row",
    backgroundColor: "#F2F2F2",
    padding: 8,
  },
  tableHeaderText: {
    fontSize: 12,
    fontWeight: 700,
  },
  tableRow: {
    flexDirection: "row",
    paddingVertical: 8,
    paddingHorizontal: 10,
    borderBottomWidth: 0.8,
    borderBottomColor: "#D5D5D3",
  },
  multiScenarioTable: {
    width: "100%",
    // borderWidth: 0.8,
    // borderColor: "#D5D5D3",
    // borderRadius: 6,
    overflow: "hidden",
  },
  multiScenarioHeaderRow: {
    flexDirection: "row",
    // backgroundColor: "#FFF59D",
    borderBottomWidth: 0.6,
    borderBottomColor: "#D5D5D3",
  },
  multiScenarioHeaderCell: {
    flex: 1,
    paddingVertical: 8,
    paddingHorizontal: 6,
    fontSize: 10,
    fontWeight: 700,
    textAlign: "center",
    borderRightWidth: 0.6,
    borderRightColor: "#D5D5D3",
  },
  multiScenarioRow: {
    flexDirection: "row",
    borderBottomWidth: 0.6,
    borderBottomColor: "#D5D5D3",
  },
  multiScenarioLabelCell: {
    width: "30%",
    paddingVertical: 8,
    paddingHorizontal: 6,
    fontSize: 10,
    fontWeight: 700,
    backgroundColor: "#F2F2F2",
    borderRightWidth: 0.6,
    borderRightColor: "#D5D5D3",
  },
  multiScenarioValueCell: {
    flex: 1,
    paddingVertical: 8,
    paddingHorizontal: 6,
    fontSize: 10,
    textAlign: "center",
    borderRightWidth: 0.6,
    borderRightColor: "#D5D5D3",
  },
  tableCell: { fontSize: 10 },
  tableFooter: { padding: 10, borderTopWidth: 0.8, borderTopColor: "#D5D5D3" },
  remarkText: { fontSize: 10 },
  breakdownWrapper: {
    flexDirection: "row",
    justifyContent: "space-between",
    gap: 18,
  },
  breakdownTable: {
    // width: "50%",
    // borderWidth: 0.8,
    // borderColor: "#E0E0E0",
    // borderRadius: 8,
    overflow: "hidden",
  },

  breakdownRow: {
    flexDirection: "row",
    alignItems: "start",
    borderBottomWidth: 0.6,
    borderBottomColor: "#D5D5D3",
  },
  breakdownRowLast: {
    borderBottomWidth: 0,
  },
  breakdownLabelCell: {
    width: "55%",
    backgroundColor: "#F2F2F2",
    paddingVertical: 10,
    paddingHorizontal: 14,
    justifyContent: "center",
  },
  breakdownLabelText: {
    fontSize: 12,
    color: "black",
  },
  breakdownValueCell: {
    paddingVertical: 10,
    paddingHorizontal: 14,
    justifyContent: "flex-start",
    alignItems: "flex-start",
    width:'100%'
  },
  breakdownValueText: {
    fontSize: 12,
    fontWeight: "bold",
  },
  breakdownListColumn: {
    width: "48%",
  },
  breakdownTitleWrapper: {
    width: "100%",
    borderTopWidth: 0.6,
    borderBottomWidth: 0.6,
    borderColor: "#D5D5D3",
    paddingVertical: 6,
    marginBottom: 12,
  },
  breakdownTitle: {
    fontSize: 14,
    fontWeight: "bold",
  },
  breakdownListItem: {
    marginBottom: 8,
  },
  breakdownListLabel: {
    fontSize: 10,
    fontWeight: "bold",
    marginBottom: 4,
  },
  breakdownSubList: {
    marginLeft: 10,
  },
  breakdownSubItem: {
    fontSize: 9,
    marginBottom: 2,
  },
  breakdownRowHorizontal: {
    flexDirection: "row",
    flexWrap: "wrap",
    marginTop: 8,
    gap: 8,
  },
  breakdownColumn: {
    minWidth: "18%",
    flex: 1,
  },
  footerLogoRow: {
    position: "absolute",
    bottom: 24,
    left: 19,
    right: 45,
    flexDirection: "row",
    alignItems: "center",
    gap: 16,
  },

  logo: { height: 15 },
  logoTwo: { height: 36, width: "auto" },
  productionTablesWrapper: {
    flexDirection: "row",
    justifyContent: "space-between",
    gap: 20,
    marginTop: 24,
  },
  productionTable: {
    width: "48%",
    borderWidth: 0.8,
    borderColor: "#D5D5D3",
    // borderRadius: 6,
    borderLeft: 0,
    borderRight: 0,
    overflow: "hidden",
  },

  productionTableRow: {
    flexDirection: "row",
    // alignItems: "center",
    // justifyContent: "space-between",

    borderBottomWidth: 0.6,
    borderBottomColor: "#D5D5D3",
    // backgroundColor: "#F8F8F8",
  },
  productionTableRowHighlighted: {
    backgroundColor: "#4A90E2",
    borderBottomWidth: 0,
  },
  productionTableRowLast: {
    borderBottomWidth: 0,
  },
  productionTableLabel: {
    flex: 1,
    fontSize: 10,
    backgroundColor: "#F8F8F8",
    paddingVertical: 6,
    // paddingHorizontal: 6,
    width: "60%",
  },
  productionTableValue: {
    fontSize: 10,
    fontWeight: "bold",
    textAlign:"center",
    // paddingHorizontal: 4,
    // paddingVertical: 2,
    width: "40%",
  },
  productionTableValueHighlighted: {
    backgroundColor: "#FFEB3B",
  },

  productionTableRowContent: {
    flexDirection: "row",
    alignItems: "center",
    flex: 1,
    justifyContent: "flex-start",
  },
  productionTableValueWrapper: {
    flexDirection: "row",
    alignItems: "center",
  },

  productionTableColorSquare: {
    width: 12,
    height: 12,
    marginTop: 4,
    marginLeft: 4,
    marginRight: 4,
    marginBottom: 8,
    borderRadius: 2,
  },
  lastPage: {
    position: "relative",
    flex: 1,
    width: "100%",
    height: "100%",
    justifyContent: "space-between",
  },
  lastPageWrapper: {
    padding: 0,
  },
  lastPageBackground: {
    position: "absolute",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    width: "100%",
    height: "100%",
    objectFit: "cover",
    objectPosition: "center",
    opacity: 0.5,
  },
  lastPageContent: {
    position: "relative",
    flex: 1,
    justifyContent: "space-between",
    padding: 48,
    paddingBottom: 96,
  },
  lastPageTopRow: {
    flexDirection: "row",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    marginBottom: 24,
  },
  lastPageLogo: {
    height: 50,
    width: "auto",
  },
  lastPageContactSection: {
    position: "absolute",
    right: 48,
    top: "35%",
    width: "40%",
    // backgroundColor: "rgba(255, 255, 255, 0.95)",
    // padding: 24,
    // borderRadius: 6,
    // borderWidth: 0.5,
    // borderColor: "#E0E0E0",
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-end",
  },
  lastPageContactTitle: {
    fontSize: 14,
    fontWeight: "bold",
    marginBottom: 20,
    color: "black",
    borderBottomWidth: 1,
    borderBottomColor: "#D5D5D3",
    paddingBottom: 8,
    width: "100%",
    textAlign: "right",
  },
  lastPageContactItem: {
    fontSize: 11,
    marginBottom: 12,
    color: "black",
    lineHeight: 1.5,
    width: "100%",
    textAlign: "right",
  },
  lastPageSocialLinks: {
    marginTop: 20,
    paddingTop: 16,
    borderTopWidth: 1,
    borderTopColor: "#E0E0E0",
    width: "100%",
    alignItems: "flex-end",
  },
  lastPageSocialLink: {
    fontSize: 10,
    color: "black",
    marginBottom: 8,
    lineHeight: 1.4,
    width: "100%",
    textAlign: "right",
  },
  lastPageFooter: {
    position: "absolute",
    bottom: 24,
    left: 48,
    right: 48,
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "flex-end",
  },
  lastPageConfidentiality: {
    fontSize: 8,
    lineHeight: 1.4,
    // maxWidth: "75%",
    color: "black",
  },
  costDetailWrapper: {
    flexDirection: "column",
    justifyContent: "flex-start",
    alignItems: "center",
    gap: 6,
    // marginTop: 8,
  },
  costDetailTable: {
    width: "80%",
    overflow: "hidden",
  },
  costDetailImageContainer: {
    width: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  costDetailImage: {
    alignSelf: "center",
    width: "350px",
    height: "350px",
    // marginBottom: 8,
    // maxHeight: 700,
  },
  costDetailMachineTitle: {
    fontSize: 20,
    fontWeight: "bold",
    color: "#3996FF",
    marginBottom: 16,
  },
  costDetailRow: {
    flexDirection: "row",
    alignItems: "start",
    borderBottomWidth: 0.6,
    borderBottomColor: "#D5D5D3",
  },
  costDetailRowLast: {
    borderBottomWidth: 0,
  },
  costDetailLabelCell: {
    width: "65%",
    backgroundColor: "#F2F2F2",
    paddingVertical: 10,
    paddingHorizontal: 8,
    justifyContent: "center",
  },
  costDetailLabelText: {
    fontSize: 11,
    color: "black",
  },
  costDetailValueCell: {
    paddingVertical: 10,
    paddingHorizontal: 14,
    justifyContent: "flex-start",
    alignItems: "flex-start",
    width: "35%",
  },
  costDetailValueText: {
    fontSize: 11,
    fontWeight: "bold",
  },
  costDetailFooterNote: {
    position: "absolute",
    bottom: 24,
    left: 30,
    right: 170,
    alignItems: "center",
    justifyContent: "center",
  },
  costDetailFooterNoteText: {
    fontSize: 8,
    fontStyle: "italic",
    textAlign: "center",
  },
});

const Doc = ({
  chartImage,
  formObj,
  pdfName,
  typeDocument,
  cppData,
  costOfCo2pp,
  currency,
  visualDonut,
  machineName,
  materialName,
  parameterName,
  jobsPerWeek,
  totalJobs,
  singleJobTime,
  machineImage,
  psImage,
  cppSum,
  workingHours,
  hotspotArray,
  highestIndex,
  hightlightKey,
  isHotSpotAvailable,
  technology_name,
  totalJobsWithWorkingHours,
  totalJobsWithoutWorkingHours,
  CO2e,
  machineDetails,
  machineImageUrl,
  materialLink,
  creatorName,
  creatorTitle,
  creatorMobile,
  creatorEmail,
  scenariosData,
  scenarios,
  allMachineDetails,
  machineDetailsArray,
  materialNamesMap,
  parameterNamesMap,
  scenarioTotalJobs,
}) => {
  const workingWeeksPerYear = parseInt(localStorage.getItem('workingWeeksPerYear') || '46');

  console.log(`[DOC-DEBUG] Doc component received - scenarios: ${JSON.stringify(scenarios)}, scenarioTotalJobs:`, scenarioTotalJobs);

  const jobYear = workingWeeksPerYear * totalJobs;
  const calculateUtilization = (jobsPerWeek) => {
    if (jobsPerWeek == null) return "Not Available";
    return Math.round(workingWeeksPerYear * jobsPerWeek) * singleJobTime;
  };
  const chartUtilization = calculateUtilization(totalJobs);
  const orderedScenarioList =
    scenariosData && scenarios && scenarios.length > 0
      ? (() => {
          // Ensure DEFAULT_SCENARIO is always included if it exists in scenariosData
          const scenarioSet = new Set(scenarios);
          // If scenariosData has DEFAULT_SCENARIO but scenarios array doesn't, add it
          if (scenariosData[constants.DEFAULT_SCENARIO] && !scenarioSet.has(constants.DEFAULT_SCENARIO)) {
            scenarioSet.add(constants.DEFAULT_SCENARIO);
          }
          return [...scenarioSet]
            .sort((a, b) => {
              if (a === constants.DEFAULT_SCENARIO) return -1;
              if (b === constants.DEFAULT_SCENARIO) return 1;
              return 0;
            })
            .filter((scenario) => scenariosData[scenario]);
        })()
      : [];

  // Get scenario data for a specific machine ID
  const getScenarioDataForMachine = (machineId) => {
    // First check if current formObj uses this machine
    if (formObj?.machine_id?.value && +formObj.machine_id.value === machineId) {
      return formObj;
    }
    
    // Then check all scenarios
    if (scenariosData) {
      for (const scenarioName of orderedScenarioList) {
        const scenarioData = scenariosData[scenarioName];
        // Check if scenarioData has costData with machine_id
        if (scenarioData?.costData?.machine_id?.value && +scenarioData.costData.machine_id.value === machineId) {
          return scenarioData.costData;
        }
        // Also check direct machine_id
        if (scenarioData?.machine_id?.value && +scenarioData.machine_id.value === machineId) {
          return scenarioData;
        }
      }
    }
    
    // Fallback to current formObj if no match found
    return formObj;
  };

  // Get hetrojobs entries that have an id (skip ones without id)
  const getValidHetrojobs = (data) => {
    const raw = Array.isArray(data?.hetrojobs) ? data.hetrojobs : [];
    return raw.filter(
      (job) =>
        job != null &&
        (job.id != null && job.id !== "")
    );
  };

  // Helper to get part_name from scenario data (check both direct and costData)
  // If the resolved name is empty/whitespace, fall back to "NA"
  const getScenarioPartName = (scenarioData) => {
    const rawName =
      scenarioData?.costData?.part_name?.value ??
      scenarioData?.part_name?.value ??
      formObj?.part_name?.value;

    if (rawName != null && String(rawName).trim() !== "") {
      return rawName;
    }

    return "NA";
  };

  // Build parts array - if multiple scenarios exist, show all scenarios; support hetrojobs (skip without id)
  // For each scenario: show main part data + all valid hetro jobs
  const buildPartsArray = () => {
    // Multiple scenarios
    if (scenariosData && orderedScenarioList.length > 1) {
      const items = [];
      orderedScenarioList.forEach((scenarioName) => {
        const scenarioData = scenariosData[scenarioName];
        const basePartName = getScenarioPartName(scenarioData);
        const validHetrojobs = getValidHetrojobs(scenarioData);
        
        // Always add main scenario part data
        const mainPartVolume = scenarioData?.costData?.part_volume?.value ?? scenarioData?.part_volume?.value ?? formObj?.part_volume?.value;
        const mainPartSupportVolume = scenarioData?.costData?.part_support_volume?.value ?? scenarioData?.part_support_volume?.value ?? formObj?.part_support_volume?.value;
        const mainNoOfParts = scenarioData?.costData?.no_of_parts?.value ?? scenarioData?.no_of_parts?.value ?? formObj?.no_of_parts?.value;
        items.push({
          label: basePartName,
          subItems: [
            { text: `Part volume: ${mainPartVolume != null && mainPartVolume !== "" ? `${mainPartVolume} cm³` : "NA"}` },
            { text: `Support volume: ${mainPartSupportVolume != null && mainPartSupportVolume !== "" ? `${mainPartSupportVolume} cm³` : "NA"}` },
            ...(mainNoOfParts != null && mainNoOfParts !== "" ? [{ text: `Parts per build: ${mainNoOfParts}` }] : []),
          ],
        });
        
        // If scenario has valid hetrojobs, add one entry per hetro job
        if (validHetrojobs.length > 0) {
          validHetrojobs.forEach((job, idx) => {
            const pv = job.part_volume ?? scenarioData?.costData?.part_volume?.value ?? scenarioData?.part_volume?.value ?? formObj?.part_volume?.value;
            const psv = job.part_support_volume ?? scenarioData?.costData?.part_support_volume?.value ?? scenarioData?.part_support_volume?.value ?? formObj?.part_support_volume?.value;
            const nop = job.no_of_parts ?? scenarioData?.costData?.no_of_parts?.value ?? scenarioData?.no_of_parts?.value ?? formObj?.no_of_parts?.value;
            const label = job.part_name ?? (validHetrojobs.length > 1 ? `${basePartName} (${idx + 1})` : `${basePartName} (Hetro ${idx + 1})`);
            items.push({
              label: label || "NA",
              subItems: [
                { text: `Part volume: ${pv != null && pv !== "" ? `${pv} cm³` : "NA"}` },
                { text: `Support volume: ${psv != null && psv !== "" ? `${psv} cm³` : "NA"}` },
                ...(nop != null && nop !== "" ? [{ text: `Parts per build: ${nop}` }] : []),
              ],
            });
          });
        }
      });
      return items;
    }
    
    // Single scenario
    const validHetrojobs = getValidHetrojobs(formObj);
    const items = [];
    const basePartName = formObj?.part_name?.value || "NA";
    
    // Always add main formObj part data
    items.push({
      label: basePartName,
      subItems: [
        { text: `Part volume: ${formObj?.part_volume?.value != null && formObj?.part_volume?.value !== "" ? `${formObj?.part_volume?.value} cm³` : "NA"}` },
        { text: `Support volume: ${formObj?.part_support_volume?.value != null && formObj?.part_support_volume?.value !== "" ? `${formObj?.part_support_volume?.value} cm³` : "NA"}` },
        ...(formObj?.no_of_parts?.value != null && formObj?.no_of_parts?.value !== "" ? [{ text: `Parts per build: ${formObj?.no_of_parts?.value}` }] : []),
      ],
    });
    
    // If formObj has valid hetrojobs, add one entry per hetro job
    if (validHetrojobs.length > 0) {
      validHetrojobs.forEach((job, idx) => {
        const pv = job.part_volume ?? formObj?.part_volume?.value;
        const psv = job.part_support_volume ?? formObj?.part_support_volume?.value;
        const nop = job.no_of_parts ?? formObj?.no_of_parts?.value;
        const label = job.part_name ?? (validHetrojobs.length > 1 ? `${basePartName} (${idx + 1})` : `${basePartName} (Hetro ${idx + 1})`);
        items.push({
          label: label || "NA",
          subItems: [
            { text: `Part volume: ${pv != null && pv !== "" ? `${pv} cm³` : "NA"}` },
            { text: `Support volume: ${psv != null && psv !== "" ? `${psv} cm³` : "NA"}` },
            ...(nop != null && nop !== "" ? [{ text: `Parts per build: ${nop}` }] : []),
          ],
        });
      });
    }
    
    return items;
  };

  // Build systems array with all unique machines, materials, and parameters
  const buildSystemsArray = () => {
    // Collect all unique machines, materials, and parameters
    const uniqueMachines = new Set();
    const uniqueMaterials = new Set();
    const uniqueParameters = new Set();
    
    // Collect from all scenarios (scenariosData always includes default/static data)
    if (scenariosData && orderedScenarioList.length > 0) {
      orderedScenarioList.forEach((scenarioName) => {
        const scenarioData = scenariosData[scenarioName];
        if (!scenarioData) return;
        
        // Get machine ID and name
        const scenarioMachineId = scenarioData?.costData?.machine_id?.value ?? scenarioData?.machine_id?.value;
        if (scenarioMachineId) {
          const machineNameForScenario = allMachineDetails?.[+scenarioMachineId]?.name;
          if (machineNameForScenario) {
            uniqueMachines.add(machineNameForScenario);
          }
        }
        
        // Get material ID and name
        const scenarioMaterialId = scenarioData?.costData?.material_id?.value ?? scenarioData?.material_id?.value;
        if (scenarioMaterialId) {
          const materialNameForScenario = materialNamesMap?.[+scenarioMaterialId];
          if (materialNameForScenario) {
            uniqueMaterials.add(materialNameForScenario);
          }
        }
        
        // Get parameter ID and name
        const scenarioParameterId = scenarioData?.costData?.parameter_id?.value ?? scenarioData?.parameter_id?.value;
        if (scenarioParameterId) {
          const parameterNameForScenario = parameterNamesMap?.[+scenarioParameterId];
          if (parameterNameForScenario) {
            uniqueParameters.add(parameterNameForScenario);
          }
        }
      });
    }
    
    // Fallback to current values if no scenarios or empty sets
    if (uniqueMachines.size === 0 && machineName) uniqueMachines.add(machineName);
    if (uniqueMaterials.size === 0 && materialName) uniqueMaterials.add(materialName);
    if (uniqueParameters.size === 0 && parameterName) uniqueParameters.add(parameterName);
    
    // Build systems array - group by machine if multiple machines exist
    if (uniqueMachines.size > 1 && allMachineDetails) {
      // Multiple machines - create entry for each machine with its materials and parameters
      return Array.from(uniqueMachines).map(machineNameValue => {
        const machineMaterials = new Set();
        const machineParameters = new Set();
        
        // Find materials and parameters used with this specific machine
        if (scenariosData) {
          Object.values(scenariosData).forEach((scenarioData) => {
            const scenarioMachineId = scenarioData?.costData?.machine_id?.value || scenarioData?.machine_id?.value;
            const machine = scenarioMachineId && allMachineDetails?.[+scenarioMachineId];
            
            if (machine?.name === machineNameValue) {
              const scenarioMaterialId = scenarioData?.costData?.material_id?.value || scenarioData?.material_id?.value;
              const scenarioParameterId = scenarioData?.costData?.parameter_id?.value || scenarioData?.parameter_id?.value;
              
              if (scenarioMaterialId && materialNamesMap?.[+scenarioMaterialId]) {
                machineMaterials.add(materialNamesMap[+scenarioMaterialId]);
              }
              if (scenarioParameterId && parameterNamesMap?.[+scenarioParameterId]) {
                machineParameters.add(parameterNamesMap[+scenarioParameterId]);
              }
            }
          });
        }
        
        // Fallback to all unique materials/parameters if none found for this machine
        if (machineMaterials.size === 0) {
          uniqueMaterials.forEach(m => machineMaterials.add(m));
        }
        if (machineParameters.size === 0) {
          uniqueParameters.forEach(p => machineParameters.add(p));
        }
        
        return {
          label: machineNameValue,
          subItems: [
            ...Array.from(machineMaterials).map(m => ({ text: m })),
            ...Array.from(machineParameters).map(p => ({ text: p }))
          ],
        };
      });
    } else {
      // Single machine or no machine details - show all materials and parameters together
      return [
        {
          label: Array.from(uniqueMachines)[0] || machineName || 'NA',
          subItems: [
            ...Array.from(uniqueMaterials).map(m => ({ text: m })),
            ...Array.from(uniqueParameters).map(p => ({ text: p }))
          ],
        },
      ];
    }
  };

  const fallbackOverview = {
    parts: buildPartsArray(),
    systems: buildSystemsArray(),

    assumptions: [
      {
        label: "Calculation based on 46 weeks of operation",
        note: "(considering scheduled maintenance and unplanned downtime)",
      },
      {
        label: "Included in the calculation:",
        subItems: [
          "All cost to run the system (licenses, software, periphery)",
          "Cost for system installation and training",
          "Consumables",
        ],
      },
      {
        label: "Not Included in the calculation:",
        subItems: [
          "Further post-processing like part cleaning, blasting, dyeing or machining",
          "Quality assurance",
          "Labor cost, overhead and facility cost",
          "Scrap rate",
        ],
      },
    ],
  };

  const overviewColumns = [
    {
      key: "parts",
      title: "Parts",
      iconSrc: "../assets/pdf7.png",
      items: fallbackOverview.parts,
      backgroundColor: "#69a0ec",
    },
    {
      key: "systems",
      title: "Systems, materials & processes",
      iconSrc: "../assets/pdf9.png",
      items: fallbackOverview.systems,
      backgroundColor: "#00E676",
    },
    {
      key: "assumptions",
      title: "General assumptions",
      iconSrc: "../assets/pdf8.png",
      items: fallbackOverview.assumptions,
      backgroundColor: "#B0B0B0",
    },
  ];

  // Single-scenario "Parts per build": include main part (formObj) + valid hetrojobs (no_of_parts)
  const getSingleScenarioPartsPerBuild = () => {
    const valid = getValidHetrojobs(formObj);
    const parts = [];

    if (formObj?.no_of_parts?.value != null && formObj.no_of_parts.value !== "") {
      parts.push(formObj.no_of_parts.value);
    }

    if (valid.length > 0) {
      valid.forEach((j) => {
        if (j.no_of_parts != null && j.no_of_parts !== "") {
          parts.push(j.no_of_parts);
        }
      });
    }

    if (parts.length === 0) {
      return "NA";
    }

    return parts.join(", ");
  };

  const costSummaryRows = [
    { label: "Parts per build", value: getSingleScenarioPartsPerBuild() },
    { label: "Process", value: parameterName ? parameterName : 'NA' },
    { label: "Build Time", value: formObj?.build_time?.value ? `${formObj?.build_time?.value} h` : 'NA' },
    { label: "CPP System CAPEX", value: formObj?.system_cost_per_part?.value ? `${formObj?.system_cost_per_part?.value} ${currency}` : 'NA' },
    { label: "CPP Recurring", value: formObj?.recurring_cost_per_part?.value ? `${formObj?.recurring_cost_per_part?.value} ${currency}` : 'NA' },
    { label: "CPP Material", value: formObj?.material_cost_per_part?.value ? `${formObj?.material_cost_per_part?.value} ${currency}` : 'NA' },
    { label: "CPP Consumables", value: formObj?.cpp_consumables?.value ? `${formObj?.cpp_consumables?.value} ${currency}` : 'NA' },
    { label: "Total AM CPP", value: formObj?.total_am_cpp?.value ? `${formObj?.total_am_cpp?.value.toFixed(2)} ${currency}` : 'NA' },
    { label: "CO2e (kg)", value: CO2e ? `${CO2e} (kgs)` : 'NA' },
    { label: "CPP Post-Processing", value: formObj?.post_processing_cost_per_part?.value ? `${formObj?.post_processing_cost_per_part?.value} ${currency}` : 'NA' },
    { label: "CPP Overhead", value: formObj?.cpp_overhead?.value ? `${formObj?.cpp_overhead?.value} ` : '0' },
  ];

  const costBreakdownList = [
    { title: "CPP System CAPEX", items: ["System Depreciation"] },
    { title: "CPP Recurring", items: ["Service contracts", "Software"] },
    { title: "CPP Material", items: ["Powder consumption"] },
    {
      title: "CPP Consumables",
      items: ["Electricity", "Process gas", "Compressed air"],
    },
    {
      title: "CPP Post-Processing",
      items: ["Cleaning", "Surfacing", "Coloring"],
    },
    
  ];

  const formatCurrencyValue = (val, options = {}) => {
    const { forceFixed } = options;
    if (val === undefined || val === null || val === "") return "NA";

    const numVal = Number(val);
    if (Number.isFinite(numVal)) {
      if (forceFixed) return `${numVal.toFixed(2)} ${currency}`;
      return `${numVal} ${currency}`;
    }

    return `${val} ${currency}`;
  };

  const formatHoursValue = (val) => {
    if (val === undefined || val === null || val === "") return "NA";
    return `${val} h`;
  };

  const getScenarioProcess = (scenarioData) => {
    const scenarioParameterId =
      scenarioData?.costData?.parameter_id?.value ??
      scenarioData?.parameter_id?.value;

    if (scenarioParameterId && parameterNamesMap?.[+scenarioParameterId]) {
      return parameterNamesMap[+scenarioParameterId];
    }

    return (
      scenarioData?.parameterName?.value ||
      scenarioData?.parameter?.value ||
      parameterName ||
      "NA"
    );
  };

  // One column per scenario, PLUS one column per valid hetro job when scenario has hetrojobs (skip jobs without id).
  // Each column can carry totalAmCpp from cppData so Total AM CPP row shows per-part value (same as charts).
  const expandedBreakdownColumns = (() => {
    if (!scenariosData || orderedScenarioList.length < 2) return [];
    return orderedScenarioList.flatMap((scenarioName) => {
      const scenarioData = scenariosData[scenarioName] || {};
      const valid = getValidHetrojobs(scenarioData);
      const basePartName = getScenarioPartName(scenarioData);
      const columns = [];
      const isDefaultScenario = scenarioName === constants.DEFAULT_SCENARIO;
      const cppDataForScenario = isDefaultScenario && Array.isArray(cppData) ? cppData : null;
      let partIndex = 0;

      columns.push({
        scenarioName,
        scenarioData,
        hetroJob: null,
        columnLabel: basePartName,
        totalAmCpp: cppDataForScenario?.[partIndex]?.total_am_cost_cm3,
      });
      partIndex += 1;

      if (valid.length > 0) {
        valid.forEach((hetroJob, idx) => {
          const rawHetroName = hetroJob?.part_name;
          const columnLabel =
            rawHetroName != null && String(rawHetroName).trim() !== ""
              ? rawHetroName
              : valid.length > 1
                ? `${basePartName} (${idx + 1})`
                : `${basePartName} (Hetro ${idx + 1})`;

          columns.push({
            scenarioName,
            scenarioData,
            hetroJob,
            columnLabel,
            totalAmCpp: cppDataForScenario?.[partIndex]?.total_am_cost_cm3,
          });
          partIndex += 1;
        });
      }

      return columns;
    });
  })();

  // Single-scenario variant: one column per part (main + hetrojobs). totalAmCpp from cppData for charts parity.
  const singleScenarioExpandedColumns = (() => {
    const valid = getValidHetrojobs(formObj);
    const basePartName = formObj?.part_name?.value || "NA";

    if (!formObj && valid.length === 0) return [];

    const columns = [];
    const hasCppData = Array.isArray(cppData) && cppData.length > 0;

    columns.push({
      scenarioName: constants.DEFAULT_SCENARIO,
      scenarioData: formObj,
      hetroJob: null,
      columnLabel: basePartName,
      totalAmCpp: hasCppData ? cppData[0]?.total_am_cost_cm3 : undefined,
    });

    if (valid.length > 0) {
      valid.forEach((hetroJob, idx) => {
        const rawHetroName = hetroJob?.part_name;
        const columnLabel =
          rawHetroName != null && String(rawHetroName).trim() !== ""
            ? rawHetroName
            : valid.length > 1
              ? `${basePartName} (${idx + 1})`
              : `${basePartName} (Hetro ${idx + 1})`;

        columns.push({
          scenarioName: constants.DEFAULT_SCENARIO,
          scenarioData: formObj,
          hetroJob,
          columnLabel,
          totalAmCpp: hasCppData ? cppData[idx + 1]?.total_am_cost_cm3 : undefined,
        });
      });
    }

    return columns;
  })();

  const multiScenarioCostRows = [
    {
      label: "Parts per build",
      getValue: (scenarioData, hetroJob) =>
        hetroJob != null
          ? (hetroJob.no_of_parts != null && hetroJob.no_of_parts !== "" ? String(hetroJob.no_of_parts) : "NA")
          : (scenarioData?.costData?.no_of_parts?.value ?? scenarioData?.no_of_parts?.value ?? formObj?.no_of_parts?.value ?? "NA"),
    },
    {
      label: "Process",
      getValue: (scenarioData, hetroJob) => getScenarioProcess(scenarioData),
    },
    {
      label: "Build Time",
      getValue: (scenarioData, hetroJob) => {
        const val =
          scenarioData?.build_time?.value ?? formObj?.build_time?.value;
        return formatHoursValue(val);
      },
    },
    {
      label: "CPP System CAPEX",
      getValue: (scenarioData, hetroJob) =>
        formatCurrencyValue(
          scenarioData?.system_cost_per_part?.value ??
            formObj?.system_cost_per_part?.value
        ),
    },
    {
      label: "CPP Recurring",
      getValue: (scenarioData, hetroJob) =>
        formatCurrencyValue(
          scenarioData?.recurring_cost_per_part?.value ??
            formObj?.recurring_cost_per_part?.value
        ),
    },
    {
      label: "CPP Material",
      getValue: (scenarioData, hetroJob) =>
        formatCurrencyValue(
          scenarioData?.material_cost_per_part?.value ??
            formObj?.material_cost_per_part?.value
        ),
    },
    {
      label: "CPP Consumables",
      getValue: (scenarioData, hetroJob) =>
        formatCurrencyValue(
          scenarioData?.cpp_consumables?.value ??
            formObj?.cpp_consumables?.value
        ),
    },
    {
      label: "Total AM CPP",
      getValue: (scenarioData, hetroJob, col) =>
        formatCurrencyValue(
          col?.totalAmCpp ??
            scenarioData?.total_am_cpp?.value ??
            formObj?.total_am_cpp?.value,
          { forceFixed: true }
        ),
    },
    {
      label: "CO2e (kg)",
      getValue: (scenarioData, hetroJob) => CO2e ? `${CO2e} (kgs)` : "NA",
    }
    // {
    //   label: "CO2e (kg)",
    //   getValue: (scenarioData) => {
    //     const val =
    //       scenarioData?.co2e?.value ??
    //       scenarioData?.CO2e?.value ??
    //       CO2e;
    //     if (val === undefined || val === null || val === "") return "NA";
    //     return `${val} (kgs)`;
    //   },
    // },
  ];

  const otherCostsColumns = [
    {
      key: "operation",
      title: "Operation/ Consumables",
      iconSrc: "../assets/pdf5.png",
      backgroundColor: "#69a0ec",
      items: [
        { label: `Electricity: 0,3 ${currency}/kWh` },
      ],
    },
    {
      key: "postProcessing",
      title: "Post processing (est.)",
      iconSrc: "../assets/pdf6.png",
      backgroundColor: "#00E676",
      items: [
        { label: `Cleaning: 0,10 – 1,50 ${currency} per part` },
        { label: `Surfacing: 0,10 –s 1,00 ${currency} per part` },
        { label: `Coloring: 1,00 – 5,00 ${currency} per build part` },
      ],
    },
    {
      key: "material",
      title: "Material",
      iconSrc: "../assets/pdf4.png",
      backgroundColor: "#B0B0B0",
      items: [
        {
          label:
            `Material price of ${formObj?.material_price?.value||0} ${currency}/kg  assumed for ${materialName}  powder`,
        },
        {
          label:
            `Refreshing rate of ${formObj?.refreshing_rate?.value||0}%  assumed for ${materialName} powder`,
        },
        { label: "No scrap rate included" },
        {
          label: "For more information,",
          linkText: "click here",
          linkHref: materialLink || null,
          hideIfNoLink: true,
        },
      ],
    },
  ];

  // Shared renderer for multi-column Cost Per Part Breakdown tables
  const renderCostBreakdownTable = (columns) => (
    <View>
      <View style={styles3.multiScenarioTable}>
        <View style={styles3.multiScenarioHeaderRow}>
          <Text
            style={[
              styles3.multiScenarioLabelCell,
              { backgroundColor: "white", fontWeight: 700 },
            ]}
          />
          {columns.map((col, colIdx) => (
            <Text
              key={`${col.scenarioName || "single"}-${colIdx}-${col.hetroJob?.id ?? "s"}`}
              style={styles3.multiScenarioHeaderCell}
            >
              {col.columnLabel}
            </Text>
          ))}
        </View>

        {multiScenarioCostRows.map((row) => {
          const values = columns.map((col) =>
            row.getValue(col.scenarioData || formObj || {}, col.hetroJob, col)
          );

          const isCO2eRow = row.label === "CO2e (kg)";
          const isPostProcessingRow = row.label === "CPP Post-Processing";
          const isOverheadRow = row.label === "CPP Overhead";
          const isOptionalRow = isCO2eRow || isPostProcessingRow || isOverheadRow;

          const shouldHideRow =
            isOptionalRow &&
            values.every(
              (val) =>
                val === undefined ||
                val === null ||
                val === "" ||
                val === "NA" ||
                val === "0"
            );

          if (shouldHideRow) {
            return null;
          }

          return (
            <View key={row.label} style={styles3.multiScenarioRow}>
              <Text style={styles3.multiScenarioLabelCell}>{row.label}</Text>
              {columns.map((col, idx) => {
                const value = values[idx];
                const isTotalAMCPP = row.label === "Total AM CPP";
                const isCO2e = row.label === "CO2e (kg)";

                return (
                  <Text
                    key={`${row.label}-${col.scenarioName || "single"}-${idx}-${col.hetroJob?.id ?? "s"}`}
                    style={[
                      styles3.multiScenarioValueCell,
                      isTotalAMCPP && {
                        backgroundColor: "#3996FF",
                        color: "white",
                        fontWeight: 700,
                      },
                      isCO2e && {
                        backgroundColor: "#08C179",
                        color: "white",
                        fontWeight: 700,
                      },
                    ]}
                  >
                    {value}
                  </Text>
                );
              })}
            </View>
          );
        })}
      </View>

      <View style={{ marginTop: 32 }}>
        <View style={styles3.breakdownTitleWrapper}>
          <Text style={styles3.breakdownTitle}>Breakdown</Text>
        </View>
        <View style={styles3.breakdownRowHorizontal}>
          {costBreakdownList.map((group) => (
            <View key={group.title} style={styles3.breakdownColumn}>
              <Text style={styles3.breakdownListLabel}>• {group.title}</Text>
              <View style={styles3.breakdownSubList}>
                {group.items.map((subItem, idx) => (
                  <Text
                    key={`${group.title}-${idx}`}
                    style={styles3.breakdownSubItem}
                  >
                    • {subItem}
                  </Text>
                ))}
              </View>
            </View>
          ))}
        </View>
      </View>
    </View>
  );

  const renderOverviewItem = (item, index) => {
    // Hide the entire item if hideIfNoLink is true and there's no link
    if (item.hideIfNoLink && !item.linkHref) {
      return null;
    }

    return (
      <View key={`${item.label}-${index}`} style={styles3.overviewItem}>
        <Text style={styles3.overviewBullet}>•</Text>
        <View style={styles3.overviewItemContent}>
          <View style={[styles3.overviewLabelWrapper]}>
            {item.linkHref ? (
              <Text style={styles3.overviewLabel}>
                {item.label}
                {item.linkText ? " " : ""}
                {item.linkText && (
                  <Link src={item.linkHref} style={styles3.overviewLink}>
                    {item.linkText}
                  </Link>
                )}
                {item.suffix ? ` ${item.suffix}` : ""}
              </Text>
            ) : (
              <Text style={styles3.overviewLabel}>{item.label}</Text>
            )}
          </View>
        {item.secondary ? (
          <Text style={styles3.overviewSecondary}>{item.secondary}</Text>
        ) : null}
        {item.note ? (
          <Text style={styles3.overviewNote}>{item.note}</Text>
        ) : null}
        {item.subItems && item.subItems.length > 0
          ? item.subItems.map((sub, subIndex) => (
              <View
                key={`${item.label}-sub-${subIndex}`}
                style={styles3.overviewSubItem}
              >
                <Text style={styles3.overviewSubBullet}>•</Text>
                <Text style={[styles3.overviewSubText]}>
                  {typeof sub === "object" && sub !== null
                    ? sub.text || sub.label
                    : sub}
                </Text>
              </View>
            ))
          : null}
      </View>
    </View>
    );
  };

  const Footer = () => (
    <View style={styles3.footerLogoRow} fixed>
      <Image style={[styles3.logo]} src="../assets/eosLogo.png" />
    </View>
  );
  const today = new Date();
  const day = today.getDate();
  const monthName = today.toLocaleString("default", { month: "long" }); // "November"
  const year = today.getFullYear();
  const formattedDate = `${day} ${monthName} ${year}`;

  const utilization = jobYear == null ? "Not Available" : Math.round(jobYear) * singleJobTime;

  return (
    <Document>
      <Page size="A4" style={[styles3.titlePageWrapper]}>
        <View style={styles3.titlePage}>
          <Image style={styles3.titleBackground} src="../assets/pdf-bg.jpeg" />
          <View style={styles3.titleContent}>
            <View style={styles3.titleTopRow}>
              <Image style={styles3.titleLogo} src="../assets/logo.png" />
            </View>
            <View style={styles3.titleBody}>
              <Text style={styles3.titleHeading}>
                Cost per part (CPP) Analysis
              </Text>
              <View style={styles3.titleMeta}>
                <Text style={styles3.titleMetaLabel}>{pdfName}</Text>
                <Text style={styles3.titleMetaLabel}>
                  {formattedDate}
                </Text>
                {creatorName ? (
                  <Text style={styles3.titleMetaLabel}>Created by: {creatorName}</Text>
                ) : null}
              </View>
            </View>
            <Text style={styles3.titleFooterText}>
              This presentation may contain confidential and privileged
              information. Any unauthorized use, disclosure or distribution of
              this document is strictly forbidden.
            </Text>
          </View>
        </View>
        <Footer />
      </Page>
      <Page size="A4" style={[styles3.page, styles3.page]}>
        <View style={styles3.headingContainer}>
          <Text style={styles3.overviewHeading}>
            {scenariosData && orderedScenarioList.length > 1 
              ? "Cost per part summary (in case of multiple scenarios)"
              : "Cost Per Part Summary"}
          </Text>
        </View>

        <View style={styles3.section}>
          <View style={styles3.graphContainer}>
            {chartImage && (
              <Image src={chartImage} style={styles3.graphImage} />
            )}
            {!(scenariosData && orderedScenarioList.length > 1) && (
              <Text style={styles3.graphCaption}>
                CPP at machine utilization of {chartUtilization === "Not Available" ? 0 : `${chartUtilization}h`}
              </Text>
            )}
          </View>
        </View>

        <View style={styles3.section}>
          <View style={styles3.tableContainer}>
            <View style={styles3.tableHeader}>
              <Text style={[styles3.tableHeaderText, { width: "25%" }]}>
                Set-Up
              </Text>
              <Text style={[styles3.tableHeaderText, { width: "25%" }]}>
                Shift
              </Text>
              <Text style={[styles3.tableHeaderText, { width: "25%" }]}>
                Utilization
              </Text>
              <Text style={[styles3.tableHeaderText, { width: "25%" }]}>
                Parts / year
              </Text>
            </View>

            {scenariosData && orderedScenarioList.length > 1 ? (
              <>
                {/* Multiple scenarios: render rows for each scenario */}
                {/* Ensure Default is always first */}
                {[...scenarios]
                  .sort((a, b) => {
                    if (a === constants.DEFAULT_SCENARIO) return -1;
                    if (b === constants.DEFAULT_SCENARIO) return 1;
                    return 0;
                  })
                  .filter(scenario => scenariosData[scenario])
                  .map((scenario, index) => {
                    const scenarioData = scenariosData[scenario];
                    const partName = scenarioData?.part_name?.value || formObj?.part_name?.value || 'NA';
                    const noOfParts = scenarioData?.no_of_parts?.value || formObj?.no_of_parts?.value || 0;
                    const scenarioPartLabel =
                      scenario && partName && partName !== 'NA'
                        ? `${scenario} - ${partName}`
                        : scenario
                          ? `${scenario} - NA`
                          : partName || 'NA';
                    
                    // Get scenario-specific total jobs (pass via props from GeneratedReport)
                    const scenarioJobsWithWH = scenarioTotalJobs?.[`${scenario}_with_wh`] || totalJobsWithWorkingHours;
                    const scenarioJobsWithoutWH = scenarioTotalJobs?.[`${scenario}_without_wh`] || totalJobsWithoutWorkingHours;
                    
                    return (
                      <React.Fragment key={scenario}>
                        <View style={styles3.tableRow}>
                          <Text
                            style={[
                              styles3.tableCell,
                              { width: "25%", fontWeight: "bold" },
                            ]}
                          >
                            {scenarioPartLabel}
                          </Text>
                          <Text style={[styles3.tableCell, { width: "25%" }]}>
                            8 h / 5 d
                          </Text>
                          <Text style={[styles3.tableCell, { width: "25%" }]}>
                            {calculateUtilization(scenarioJobsWithWH)} h
                          </Text>
                          <Text style={[styles3.tableCell, { width: "25%" }]}>
                            {Math.trunc(+((workingWeeksPerYear * scenarioJobsWithWH) * +noOfParts))}
                          </Text>
                        </View>

                        <View style={styles3.tableRow}>
                          <Text style={[styles3.tableCell, { width: "25%" }]}>
                            {scenarioPartLabel}
                          </Text>
                          <Text style={[styles3.tableCell, { width: "25%" }]}>
                            24 h / 7 d
                          </Text>
                          <Text style={[styles3.tableCell, { width: "25%" }]}>
                            {calculateUtilization(scenarioJobsWithoutWH)} h
                          </Text>
                          <Text style={[styles3.tableCell, { width: "25%" }]}>
                            {Math.trunc(+((workingWeeksPerYear * scenarioJobsWithoutWH) * +noOfParts))}
                          </Text>
                        </View>
                      </React.Fragment>
                    );
                  })}
                
               
              </>
            ) : (
              // Single scenario: original rendering
              <>
                <View style={styles3.tableRow}>
                  <Text
                    style={[
                      styles3.tableCell,
                      { width: "25%", fontWeight: "bold" },
                    ]}
                  >
                    {formObj.part_name?.value ? `${formObj.part_name?.value} ` : 'NA'}
                  </Text>
                  <Text style={[styles3.tableCell, { width: "25%" }]}>
                    8 h / 5 d
                  </Text>
                  <Text style={[styles3.tableCell, { width: "25%" }]}>{calculateUtilization(totalJobsWithWorkingHours)} h</Text>
                  <Text style={[styles3.tableCell, { width: "25%" }]}>{Math.trunc(+((workingWeeksPerYear * totalJobsWithWorkingHours) * +formObj?.no_of_parts?.value))} </Text>
                </View>

                <View style={styles3.tableRow}>
                  <Text style={[styles3.tableCell, { width: "25%" }]}>
                   {formObj.part_name?.value ? `${formObj.part_name?.value}` : 'NA'}
                  </Text>
                  <Text style={[styles3.tableCell, { width: "25%" }]}>
                    24 h / 7 d
                  </Text>
                  {/* Jobs per year*turn around time = utilization */}
                  <Text style={[styles3.tableCell, { width: "25%" }]}>{calculateUtilization(totalJobsWithoutWorkingHours)} h</Text>
                  <Text style={[styles3.tableCell, { width: "25%" }]}>{Math.trunc(+((workingWeeksPerYear * totalJobsWithoutWorkingHours) * +formObj?.no_of_parts?.value))} </Text>
                </View>
              </>
            )}
          </View>
         
        </View>
        <Footer />
      </Page>

      <Page size="A4" style={[styles3.page, styles3.page]}>
        <View style={styles3.section}>
          <View style={styles3.headingContainer}>
            <Text style={styles3.overviewHeading}>
              Overview Of Cases Analyzed
            </Text>
          </View>
          <View style={styles3.overviewColumns}>
            {overviewColumns.map((column) => (
              <View key={column.key} style={styles3.overviewColumn}>
                <View style={styles3.overviewColumnHeader}>
                  <Text style={[styles3.overviewColumnTitle, { width: "70%" }]}>
                    {column.title}
                  </Text>
                  <Image
                    src={column.iconSrc}
                    style={[
                      styles3.overviewIconImage,
                      { backgroundColor: column.backgroundColor },
                    ]}
                  />
                </View>
                <View style={styles3.overviewColumnDivider} />
                {column.items.map((item, index) =>
                  renderOverviewItem(item, index)
                )}
              </View>
            ))}
          </View>
        </View>
        <Footer />
      </Page>

      <Page size="A4" style={[styles3.page, styles3.page]}>
        <View style={styles3.section}>
          <View style={styles3.headingContainer}>
            <Text style={styles3.overviewHeading}>Cost Per Part Breakdown</Text>
          </View>
          {(() => {
            const hasMultiScenarios = scenariosData && orderedScenarioList.length > 1;
            const columns =
              hasMultiScenarios
                ? expandedBreakdownColumns
                : singleScenarioExpandedColumns.length > 1
                  ? singleScenarioExpandedColumns
                  : null;

            if (columns && columns.length > 0) {
              return renderCostBreakdownTable(columns);
            }

            return (
            <View style={styles3.breakdownWrapper}>
              <View style={[styles3.breakdownTable, { width: "60%" }]}>
                <View
                  style={{
                    flexDirection: "row",
                    backgroundColor: "#FFF59D",
                    borderBottomWidth: 0.6,
                    borderBottomColor: "#D5D5D3",
                  }}
                >
                  <View
                    style={[
                      styles3.breakdownLabelCell,
                      { backgroundColor: "white !important" },
                    ]}
                  >
                    <Text
                      style={[
                        styles3.breakdownLabelText,
                        { textAlign: "center" },
                      ]}
                    />
                  </View>
                  <View style={[styles3.breakdownLabelCell, { backgroundColor: "white !important" ,borderTopWidth: 0.6,borderTopColor: "#D5D5D3" }]}>
                    <Text
                      style={[styles3.breakdownLabelText, { textAlign: "left" }]}
                    >
                      {formObj.part_name?.value ? `${formObj.part_name?.value} ` : 'NA'}
                    </Text>
                  </View>
                </View>
                {costSummaryRows.map((row, index) => {
                  const isTotalAMCPP = row.label === "Total AM CPP";
                  const isCO2e = row.label === "CO2e (kg)";
                  const isPostProcessing =
                  row.label === "CPP Post-Processing";
                const isOverhead = row.label === "CPP Overhead";

                const shouldHide =
                  (isCO2e || isPostProcessing || isOverhead) &&
                  (!row.value ||
                    !row||row==="NA"||row==="0"||
                    row.value === "NA" ||
                    row.value === "0");

                if (shouldHide) {
                  return null;
                }
                  return (
                    <View
                      key={`${row.label}-${index}`}
                      style={[
                        styles3.breakdownRow,
                        index === costSummaryRows.length - 1 &&
                          styles3.breakdownRowLast,
                      ]}
                    >
                      <View style={styles3.breakdownLabelCell}>
                        <Text style={styles3.breakdownLabelText}>
                          {row.label}
                        </Text>
                      </View>
                      <View
                        style={[
                          styles3.breakdownValueCell,
                          isTotalAMCPP && { backgroundColor: "#3996FF" },
                          isCO2e && { backgroundColor: "#08C179" },
                        ]}
                      >
                        <Text
                          style={[
                            styles3.breakdownValueText,
                            (isTotalAMCPP || isCO2e) && { color: "white" },
                          ]}
                        >
                          {row.value}
                        </Text>
                      </View>
                    </View>
                  );
                })}
              </View>
              <View style={[styles3.breakdownListColumn, { width: "30%" }]}>
                <View style={styles3.breakdownTitleWrapper}>
                  <Text style={styles3.breakdownTitle}>Breakdown</Text>
                </View>
                {costBreakdownList.map((group) => (
                  <View key={group.title} style={styles3.breakdownListItem}>
                    <Text style={styles3.breakdownListLabel}>
                      • {group.title}
                    </Text>
                    <View style={styles3.breakdownSubList}>
                      {group.items.map((subItem, idx) => (
                        <Text
                          key={`${group.title}-${idx}`}
                          style={styles3.breakdownSubItem}
                        >
                          • {subItem}
                        </Text>
                      ))}
                    </View>
                  </View>
                ))}
              </View>
            </View>
            );
          })()}
        </View>
        <Footer />
      </Page>
      <Page size="A4" style={styles3.page}>
        <View style={styles3.section}>
          <View style={styles3.headingContainer}>
            <Text style={styles3.overviewHeading}>Production Scheduling</Text>
          </View>
          {psImage && (
            <View style={styles3.graphContainer}>
              <Image
                src={psImage}
                style={{
                  width: "100%",
                  maxWidth: 750,
                  height: "auto",
                  marginTop: 20,
                }}
              />
            </View>
          )}

          <View style={styles3.productionTablesWrapper}>
            {/* Per Year Table */}
            <View style={styles3.productionTable}>
              <View style={[styles3.productionTableRow]}>
                <Text style={styles3.productionTableLabel}>
                  Weeks active per year:
                </Text>
                <View style={styles3.productionTableValueWrapper}>
                  <Text style={styles3.productionTableValue}>{workingWeeksPerYear}</Text>
                </View>
              </View>
              <View style={[styles3.productionTableRow]}>
                <Text style={styles3.productionTableLabel}>Jobs per week:</Text>
                <View style={styles3.productionTableValueWrapper}>
                  <Text style={styles3.productionTableValue}>{totalJobs.toFixed(2)}</Text>
                </View>
              </View>
              <View style={[styles3.productionTableRow]}>
                <Text style={styles3.productionTableLabel}>Jobs per year:</Text>
                <View style={styles3.productionTableValueWrapper}>
                  <Text style={styles3.productionTableValue}>{jobYear.toFixed(2)}</Text>
                </View>
              </View>
              <View style={[styles3.productionTableRow]}>
                <Text style={styles3.productionTableLabel}>
                  Utilization (BT + CD) per year:
                </Text>
                <View style={styles3.productionTableValueWrapper}>
                  <Text style={styles3.productionTableValue}>{utilization} h</Text>
                </View>
              </View>
              <View
                style={[
                  styles3.productionTableRow,
                  styles3.productionTableRowHighlighted,
                  styles3.productionTableRowLast,
                ]}
              >
                <Text
                  style={[styles3.productionTableLabel, { fontWeight: 800 }]}
                >
                  Throughput per year:
                </Text>
                <View style={styles3.productionTableValueWrapper}>
                  <Text
                    style={[
                      { color: "white" },
                      styles3.productionTableValue,
                      // styles3.productionTableValueHighlighted,
                    ]}
                  >
                    {Math.trunc(+(jobYear * +formObj?.no_of_parts?.value))}
                  </Text>
                </View>
              </View>
            </View>
            {/* Color Squares Column - Centered between tables */}
            <View style={[{  marginLeft:4,marginRight:4 }]}>
                <View
                  style={[
                    styles3.productionTableColorSquare,
                    { backgroundColor: "#D3D3D3" },
                  ]}
                />
                <View
                  style={[
                    styles3.productionTableColorSquare,
                    { backgroundColor: "#4A90E2" },
                  ]}
                />
                <View
                  style={[
                    styles3.productionTableColorSquare,
                    { backgroundColor: "#87CEEB" },
                  ]}
                />
                <View
                  style={[
                    styles3.productionTableColorSquare,
                    { backgroundColor: "#696969" },
                  ]}
                />
            </View>
            {/* Per Job Table */}
            <View style={styles3.productionTable}>
              <View style={[styles3.productionTableRow]}>
                <View style={styles3.productionTableRowContent}>
                  <Text style={styles3.productionTableLabel}>
                    Set up time per job:
                  </Text>
                </View>
                <View style={styles3.productionTableValueWrapper}>
                  <Text style={styles3.productionTableValue}>{formObj?.setup_time?.value.toFixed(2)} h</Text>
                </View>
              </View>
              <View style={[styles3.productionTableRow]}>
                <View style={styles3.productionTableRowContent}>
                  <Text style={styles3.productionTableLabel}>
                    Build time (BT) per job:
                  </Text>
                </View>
                <View style={styles3.productionTableValueWrapper}>
                  <Text style={styles3.productionTableValue}>{formObj?.build_time?.value} h</Text>
                </View>
              </View>
              <View style={[styles3.productionTableRow]}>
                <View style={styles3.productionTableRowContent}>
                  <Text style={styles3.productionTableLabel}>
                    Cool time per job:
                  </Text>
                </View>
                <View style={styles3.productionTableValueWrapper}>
                  <Text style={styles3.productionTableValue}>{formObj?.cool_down_time_in_system?.value} h</Text>
                </View>
              </View>
              <View style={[styles3.productionTableRow]}>
                <View style={styles3.productionTableRowContent}>
                  <Text style={styles3.productionTableLabel}>
                    Unpacking time per job:
                  </Text>
                </View>
                <View style={styles3.productionTableValueWrapper}>
                  <Text style={styles3.productionTableValue}>{formObj?.unpacking_time_per_job?.value.toFixed(2)} h</Text>
                </View>
              </View>
              <View
                style={[
                  styles3.productionTableRow,
                  styles3.productionTableRowHighlighted,
                  styles3.productionTableRowLast,
                ]}
              >
                <View style={styles3.productionTableRowContent}>
                  <Text
                    style={[
                      styles3.productionTableLabel,
                      { fontWeight: 800 },
                    ]}
                  >
                    Total time per job:
                  </Text>
                </View>
                <View style={styles3.productionTableValueWrapper}>
                  <Text
                    style={[
                      { color: "white" },
                      styles3.productionTableValue,
                      // styles3.productionTableValueHighlighted,
                    ]}
                  >
                   {singleJobTime || 0} h
                  </Text>
                </View>
              </View>
            </View>
          </View>
        </View>
        <Footer />
      </Page>

      {/* Render Cost Calculation Detail page for each unique machine */}
      {(() => {
        // Get machines from machineDetailsArray first, then from allMachineDetails object, then fallback to single machineDetails
        let machinesToRender = [];
        if (machineDetailsArray && machineDetailsArray.length > 0) {
          machinesToRender = machineDetailsArray;
        } else if (allMachineDetails && Object.keys(allMachineDetails).length > 0) {
          // Convert allMachineDetails object to array
          machinesToRender = Object.values(allMachineDetails);
        } else if (machineDetails) {
          machinesToRender = [machineDetails];
        }
        return machinesToRender;
      })().map((machine, index) => {
        const machineId = machine?.machine_id;
        const machineFormData = getScenarioDataForMachine(machineId);
        const currentMachineName = machine?.name || machineName;
        const currentMachineImageUrl = machine?.image_url || machineImageUrl || "../assets/image1.png";
        const currentMachineDetails = machine || machineDetails;
        
        return (
          <Page key={machineId || index} size="A4" style={[styles3.page, styles3.page]}>
            <View style={styles3.section}>
              <View style={styles3.headingContainer}>
                <Text style={styles3.overviewHeading}>Cost Calculation Detail – System & Recurring Costs</Text>
              </View>
              <View style={styles3.costDetailWrapper}>
                <View style={styles3.costDetailImageContainer}>
                  <Image src={currentMachineImageUrl} style={styles3.costDetailImage} />
                </View>
                <View style={styles3.costDetailTable}>
                  <Text style={styles3.costDetailMachineTitle}>{currentMachineName}</Text>
                  <View style={[styles3.costDetailRow]}>
                    <View style={[styles3.costDetailLabelCell]}>
                      <Text style={styles3.costDetailLabelText}>Initial invest incl. periphery</Text>
                    </View>
                    <View style={[styles3.costDetailValueCell]}>
                      <Text style={styles3.costDetailValueText}>
                        {machineFormData?.initial_investment?.value ? `${parseFloat(machineFormData?.initial_investment?.value).toLocaleString('de-DE')} ${currency}` : 'NA'}
                      </Text>
                    </View>
                  </View>
                  <View style={[styles3.costDetailRow]}>
                    <View style={[styles3.costDetailLabelCell]}>
                      <Text style={styles3.costDetailLabelText}>Recurring expenses</Text>
                    </View>
                    <View style={[styles3.costDetailValueCell]}>
                      <Text style={styles3.costDetailValueText}>
                        {machineFormData?.service_expense?.value ? `${parseFloat(machineFormData?.service_expense?.value).toLocaleString('de-DE')} ${currency}/yr` : machineFormData?.recurring_expense?.value ? `${parseFloat(machineFormData?.recurring_expense?.value).toLocaleString('de-DE')} ${currency}/yr` : 'NA'}
                      </Text>
                    </View>
                  </View>
                  {/* <View style={[styles3.costDetailRow]}>
                    <View style={styles3.costDetailLabelCell}>
                      <Text style={styles3.costDetailLabelText}>EOSPRINT Build Plan²</Text>
                    </View>
                    <View style={styles3.costDetailValueCell}>
                      <Text style={styles3.costDetailValueText}>
                        {machineFormData?.software_expense?.value ? `${parseFloat(machineFormData?.software_expense?.value).toLocaleString('de-DE')} ${currency}/yr.` : 'NA'}
                      </Text>
                    </View>
                  </View> */}
                  <View style={[styles3.costDetailRow,]}>
                    <View style={[styles3.costDetailLabelCell,]}>
                      <Text style={styles3.costDetailLabelText}>Depreciation period</Text>
                    </View>
                    <View style={[styles3.costDetailValueCell,]}>
                      <Text style={styles3.costDetailValueText}>
                        {machineFormData?.depreciation_period?.value ? `${machineFormData?.depreciation_period?.value} years` : 'NA'}
                      </Text>
                    </View>
                  </View>
                  <View style={[styles3.costDetailRow]}>
                    <View style={styles3.costDetailLabelCell}>
                      <Text style={styles3.costDetailLabelText}>Assumed interest rate</Text>
                    </View>
                    <View style={styles3.costDetailValueCell}>
                      <Text style={styles3.costDetailValueText}>
                        {machineFormData?.interest_rate?.value ? `${machineFormData?.interest_rate?.value} %` : 'NA'}
                      </Text>
                    </View>
                  </View>
                  <View style={[styles3.costDetailRow,]}>
                    <View style={[styles3.costDetailLabelCell,]}>
                      <Text style={styles3.costDetailLabelText}>Setup / Unpacking time</Text>
                    </View>
                    <View style={[styles3.costDetailValueCell,]}>
                      <Text style={styles3.costDetailValueText}>
                        {currentMachineDetails?.step_time ? `${currentMachineDetails?.step_time} h` : 'NA'}
                      </Text>
                    </View>
                  </View>
                  <View style={[styles3.costDetailRow, styles3.costDetailRowLast]}>
                    <View style={[styles3.costDetailLabelCell]}>
                      <Text style={styles3.costDetailLabelText}>Consumables</Text>
                    </View>
                    <View style={[styles3.costDetailValueCell]}>
                      <Text style={styles3.costDetailValueText}>
                        {currentMachineDetails?.consumables ? `${currentMachineDetails?.consumables} ${currency}/h` : 'NA'}
                      </Text>
                    </View>
                  </View>
                </View>
              </View>
            </View>
            <View style={styles3.costDetailFooterNote}>
              <Text style={styles3.costDetailFooterNoteText}>
                Recurring expenses include service and software expenses
              </Text>
            </View>
            <Footer />
          </Page>
        );
      })}

      <Page size="A4" style={[styles3.page, styles3.page]}>
        <View style={styles3.section}>
          <View style={styles3.headingContainer}>
            <Text style={styles3.overviewHeading}>Cost calculation detail – Other costs</Text>
          </View>
          <View style={styles3.overviewColumns}>
            {otherCostsColumns.map((column) => (
              <View key={column.key} style={styles3.overviewColumn}>
                <View style={styles3.overviewColumnHeader}>
                  <Text style={[styles3.overviewColumnTitle, { width: "70%" }]}>
                    {column.title}
                  </Text>
                  <Image
                    src={column.iconSrc}
                    style={[
                      styles3.overviewIconImage,
                      { backgroundColor: column.backgroundColor },
                    ]}
                  />
                </View>
                <View style={styles3.overviewColumnDivider} />
                {column.items.map((item, index) =>
                  renderOverviewItem(item, index)
                )}
              </View>
            ))}
          </View>
        </View>
        <Footer />
      </Page>

      <Page size="A4" style={[styles3.lastPageWrapper]}>
        <View style={styles3.lastPage}>
          <Image style={styles3.lastPageBackground} src="../assets/pdg-bg1.jpg" />
          <View style={styles3.lastPageContent}>
            <View style={styles3.lastPageTopRow}>
              <View>
                <Image style={styles3.lastPageLogo} src="../assets/logo.png" />
                
              </View>
            </View>
            <View style={styles3.lastPageContactSection}>
              <Text style={styles3.lastPageContactTitle}>Contact</Text>
              <Text style={styles3.lastPageContactItem}>{creatorName}</Text>
              {creatorTitle ? <Text style={styles3.lastPageContactItem}>{creatorTitle}</Text> : null}
              {creatorMobile ? <Text style={styles3.lastPageContactItem}>Mobile {creatorMobile}</Text> : null}
              {creatorEmail ? <Text style={styles3.lastPageContactItem}>www.eos.info | &nbsp;
              {creatorEmail}</Text> :<Text style={styles3.lastPageContactItem}> www.eos.info </Text>} 
              <View style={styles3.lastPageSocialLinks}>
                <Text style={styles3.lastPageSocialLink}>linkedin.com/in</Text>
                <Text style={styles3.lastPageSocialLink}>youtube.com/user/EOSGmb</Text>
                <Text style={styles3.lastPageSocialLink}>@eos.global</Text>
              </View>
            </View>
            <View style={styles3.lastPageFooter}>
              <Text style={styles3.lastPageConfidentiality}>
                This presentation may contain confidential and/or privileged information. Any unauthorized copying, disclosure or distribution of the material in this document is strictly forbidden.
              </Text>
            </View>
            
          </View>
        </View>
      </Page>
    </Document>
  );
};

function PdfGenerator({
  chartImage,
  formFields,
  donutImage,
  typeDocument,
  pdfName,
  cppData,
  costOfCo2pp,
  currency,
  visualDonut,
  machineName,
  materialName,
  parameterName,
  jobsPerWeek,
  totalJobs,
  singleJobTime,
  machineImage,
  psImage,
  initialDocumentState,
  cppSum,
  workingHours,
  hotspotArray,
  highestIndex,
  hightlightKey,
  isHotSpotAvailable,
  technology_name,
  totalJobsWithWorkingHours,
  totalJobsWithoutWorkingHours,
  CO2e,
  machineDetails,
  machineImageUrl,
  materialLink,
  creatorName,
  creatorTitle,
  creatorMobile,
  creatorEmail,
  scenariosData,
  scenarios,
  allMachineDetails,
  machineDetailsArray,
  materialNamesMap,
  materialNamesArray,
  parameterNamesMap,
  parameterNamesArray,
  scenarioTotalJobs,
}) {
  const [formFieldsObj, setFormFieldsObj] = React.useState();

  let temp = true;
  React.useEffect(() => {
    // console.log('formFields', formFields)
    setFormFieldsObj(formFields);
  }, [formFields]);

  return (
    <div>
      {/* <div id="faq-header"> */}
      {formFieldsObj && (
        <BlobProvider
          document={
            <Doc
              chartImage={chartImage}
              formObj={formFieldsObj}
              donutImage={donutImage}
              typeDocument={typeDocument}
              pdfName={pdfName}
              cppData={cppData}
              costOfCo2pp={costOfCo2pp}
              currency={currency}
              visualDonut={visualDonut}
              machineName={machineName}
              materialName={materialName}
              parameterName={parameterName}
              jobsPerWeek={jobsPerWeek}
              totalJobs={totalJobs}
              singleJobTime={singleJobTime}
              machineImage={machineImage}
              psImage={psImage}
              cppSum={cppSum}
              workingHours={workingHours}
              hotspotArray={hotspotArray}
              highestIndex={highestIndex}
              hightlightKey={hightlightKey}
              isHotSpotAvailable={isHotSpotAvailable}
              technology_name={technology_name}
              totalJobsWithWorkingHours={totalJobsWithWorkingHours}
              totalJobsWithoutWorkingHours={totalJobsWithoutWorkingHours}
              CO2e={CO2e}
              machineDetails={machineDetails}
              machineImageUrl={machineImageUrl}
              materialLink={materialLink}
              creatorName={creatorName}
              creatorTitle={creatorTitle}
              creatorMobile={creatorMobile}
              creatorEmail={creatorEmail}
              scenariosData={scenariosData}
              scenarios={scenarios}
              allMachineDetails={allMachineDetails}
              machineDetailsArray={machineDetailsArray}
              materialNamesMap={materialNamesMap}
              materialNamesArray={materialNamesArray}
              parameterNamesMap={parameterNamesMap}
              parameterNamesArray={parameterNamesArray}
              scenarioTotalJobs={scenarioTotalJobs}

            />
          }
        >
          {({ blob, url, loading, error }) => {
            // Do whatever you need with blob here
            // console.log("data:image/svg+xml;base64," + donutImage);
            // console.log("Blob", blob);
            // console.log("PDF JOBS", jobsPerWeek);
            // console.log("highestIndex", highestIndex);
            if (!loading && temp) {
              temp = false;

              if (typeDocument === 0) {
                toast.info(NOTIFICATION_MESSAGES.PDF_WAIT_NOTIFY);

                window.open(url, "_blank");
                initialDocumentState();
              } else if (typeDocument === 1) {
                let data = new FormData();
                data.append("file", blob);

                toast.info(NOTIFICATION_MESSAGES.WAIT_NOTIFY);
                axios
                  .post(`${config.serviceUrl}client-data`, data, {
                    headers: {
                      accept: "application/json",
                      "Accept-Language": "en-US,en;q=0.8",
                      "Content-Type": `multipart/form-data; boundary=${data._boundary}`,
                    },
                  })
                  .then(function (response) {
                    if (response.data) {
                      toast.success(NOTIFICATION_MESSAGES.SUCCESS_NOTIFY);
                      saveAs(
                        `${config.serviceUrl}${response.data.data}`,
                        `${pdfName}.pptx`
                      );
                      initialDocumentState();
                    }
                  })
                  .catch(function (error) {
                    console.log(error);
                    initialDocumentState()
                  });
              }
            }
            return "";
          }}
        </BlobProvider>
      )}
    </div>
  );
}

export default PdfGenerator;
